import React from 'react';
import styles from './QuestionsAndAnswers.module.css';

interface Props {
  id: number;
  title: string;
  uri: string;
  numberOfAnswers: number;
  i18n: (key: string, count?: number) => string;
}

export function QuestionsAndAnswers(props: Props): React.ReactElement {
  const { id, title, uri, numberOfAnswers, i18n } = props;

  function getAnswersLabel(
    i18n: (key: string, count?: number) => string,
    count: number
  ): string {
    switch (count) {
      case 0:
        return i18n('questions-and-answers.no-answers');
      case 1:
        return i18n('questions-and-answers.answer', 1);
      default:
        return i18n('questions-and-answers.answers', count);
    }
  }

  const answersLabel = getAnswersLabel(i18n, numberOfAnswers);

  return (
    <div key={id}>
      <a href={uri} className={styles.link}>
        <div className={styles.question}>{title}</div>
        <div className={styles.answers}>{answersLabel}</div>
      </a>
    </div>
  );
}
